import script from "./PizzaCustomizationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PizzaCustomizationModal.vue?vue&type=script&setup=true&lang=ts"

import "./PizzaCustomizationModal.vue?vue&type=style&index=0&id=877a3732&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-877a3732"]])

export default __exports__